import { FullNameFormatterType } from '../../types';
export const contactParser = {
  parseName(firstName, lastName, defaultName, fullNameFormatter) {
    if (!!firstName && !!lastName) {
      return fullNameFormatter ? fullNameFormatter({
        type: FullNameFormatterType.FIRST_NAME_AND_LAST_NAME,
        firstName,
        lastName
      }) : `${firstName} ${lastName}`;
    }
    if (!!firstName && !lastName) {
      return fullNameFormatter ? fullNameFormatter({
        type: FullNameFormatterType.FIRST_NAME_ONLY,
        firstName
      }) : firstName;
    }
    if (!firstName && !!lastName) {
      return fullNameFormatter ? fullNameFormatter({
        type: FullNameFormatterType.LAST_NAME_ONLY,
        lastName
      }) : lastName;
    }
    return defaultName;
  }
};
//# sourceMappingURL=contact.js.map